module.exports = __webpack_public_path__ + "static/media/PET.2eaf4754.png";